export const DEFAULT_BEDROOMS_AMOUNT = [1, 2, 3, 4, 5];
